export const emailIpWarmingAppGroupIdSchedule = "/email/ip_warming/:app_group_id/schedule";
